<template>
  <p class="RwvContentMarkdown" v-html="parseMarkdown(markdown)"></p>
</template>

<script>
import marked from "marked"

marked.setOptions({
  sanitize: true
});

export default {
  name: "RwvContentMarkdown",
  props: {
    markdown: {
      type: String,
      required: true
    },
  },
  methods: {
    parseMarkdown(markdown) {
      // return DOMPurify.sanitize(marked(markdown))
      return marked(markdown);
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}
</style>
